// Swatch click on a product card swaps the card's image and links in place (ported from boody-japan,
// see snippets/custom-sibling-card.liquid). Loaded once from layout/theme.liquid.
if (!window.customSiblingCardClickAdded) {
  document.addEventListener('click', function(e) {
    const swatchWrapper = e.target.closest('.js-custom-card-swatch');
    if (!swatchWrapper) return;

    const newImgSrc = swatchWrapper.dataset.img;
    const newUrl = swatchWrapper.dataset.url;
    if (!newImgSrc || !newUrl) return;

    e.preventDefault();
    e.stopPropagation();

    const card = swatchWrapper.closest('product-card, .product-item, .product-card-wrapper, .product-cross-sell');
    if (!card) return;

    const pictures = card.querySelectorAll('picture');
    pictures.forEach(pic => {
      pic.querySelectorAll('source').forEach(src => src.setAttribute('srcset', newImgSrc));
      const img = pic.querySelector('img');
      if (img) { img.src = newImgSrc; img.srcset = newImgSrc; }
    });

    const fallbackImgs = card.querySelectorAll('img:not(.swatch-color)');
    fallbackImgs.forEach(img => {
      if (!img.closest('.custom-sibling-card-root')) {
        img.src = newImgSrc;
        if (img.srcset) img.srcset = newImgSrc;
      }
    });

    card.querySelectorAll('a').forEach(link => {
      if (link.href.includes('/products/') && !link.closest('.custom-sibling-card-root') && !link.classList.contains('quick-add-btn')) {
        link.href = newUrl;
      }
    });

    // The Quick Buy modal's target product is a custom-element attribute, not an <a href>, so the
    // loop above never touches it - without this, Quick Buy keeps opening whichever color was
    // originally server-rendered for this card, regardless of which swatch was clicked.
    const quickBuyModal = card.querySelector('quick-buy-modal');
    if (quickBuyModal) {
      quickBuyModal.setAttribute('product-url', newUrl);
    }

    // The "+N more colors" link points at product.url at render time, which is excluded from the
    // /products/ link rewrite above (it lives inside .custom-sibling-card-root) - keep it pointed
    // at whichever color is now active instead of the one this card loaded with.
    const overflowLink = card.querySelector('.custom-sibling-card-overflow-link');
    if (overflowLink) {
      overflowLink.href = newUrl;
    }

    card.querySelectorAll('.js-custom-card-swatch :is(.color-swatch, .thumbnail-swatch)').forEach(sw => {
      sw.classList.remove('is-active', 'is-selected');
      sw.setAttribute('aria-selected', 'false');
    });

    const activeSwatch = swatchWrapper.querySelector('.color-swatch, .thumbnail-swatch');
    if (activeSwatch) {
      activeSwatch.classList.add('is-active', 'is-selected');
      activeSwatch.setAttribute('aria-selected', 'true');
    }
  });

  window.customSiblingCardClickAdded = true;
}
